import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../../config/theme/baseTheme";
import {
  fontStyles,
  sharedStyles,
  geocodedAddressStyles,
  tagStyles,
  modalStyles,
  detailsHeaderStyles,
  timelineStyles,
  useSideModalCloseOpenStyles,
  tabularSectionItemContentStyles,
  tabularSectionCratesStyles,
  deliveryProofSectionStyles,
} from "./sharedStyles";
import { useColorStyles } from "./Colores.styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ...sharedStyles(theme),
    root: {
      flexGrow: 1,
    },
    titleContainer: {
      "& .headingContainer": {
        flexDirection: "column",
        "& .titleHeading": {
          ...fontStyles.heading,
          "& .content": {
            fontWeight: 600,
          },
        },
        "& .titleContent": {
          ...fontStyles.content,
          "&.link": {
            cursor: "pointer",
          },
        },
      },
      "& .tagContainer": {
        marginLeft: theme.spacing(1),
        "& .tag": {
          ...tagStyles(theme).base,
          ...useColorStyles(theme)
        },
      },
      "& .editIcon": {
        paddingLeft: theme.spacing(1.5),
        "& .icon": {
          cursor: "pointer",
          verticalAlign: "middle",
        },
      },
    },
    contentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .geocodedAddress": {
        paddingBottom: theme.spacing(2),
         ...geocodedAddressStyles(theme),
      },
      "& .detailsHeader": {
        ...detailsHeaderStyles(theme).container,
        "& .detailsHeaderItem": {
          ...detailsHeaderStyles(theme).item,
        },
      },
      "& .contentHubAddress": {
        display: "flex",
        flexDirection: "column",
        "& .main": {
          display: "flex",
          flexDirection: "column",
        },
        "& .title": {
          ...fontStyles.subHeading,
        },
        "& .content": {
          paddingTop: "16px",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "20px",
        },
        "& .subSection": {
          paddingTop: "16px",
          display: "flex",
        },
        "& .subSectionTitle": {
          fontSize: "14px",
          fontWeight: 600,
        },
        "& .subSectionContent": {
          fontSize: "14px",
          fontWeight: 500,
          paddingLeft: "8px",
        },
        "& .detailsHeaderItem": {
          paddingBottom: theme.spacing(2),
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .editAddress": {
            height: "18px",
            width: "18px",
            cursor: "pointer",
          },
          "& .headerItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& .contactItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& p": {
            ...fontStyles.normalText,
          },
          "& .name": {
            fontWeight: 600,
          },
          "&.geocodedAddress": {
            paddingBottom: "6px",
            ...geocodedAddressStyles(theme),
          },
          "& .contactMobile": {
            marginRight: theme.spacing(5),
          },
          "& .logo": {
            width: 24,
            height: 24,
          },
          "& .contact": {
            "& a": {
              ...fontStyles.normalText,
              fontWeight: 600,
              textDecoration: "none",
              color: theme.palette.text.primary,
            },
            paddingLeft: theme.spacing(1),
            "&.mobile": {
              paddingLeft: theme.spacing(0.25),
            },
          },
        },
      },
      "& .detailsContent": {
        flexDirection: "column",
        flexWrap: "nowrap",
        padding: theme.spacing(3, 0, 2, 0),
        "& .contentRow": {
          paddingBottom: theme.spacing(3),
          "&.hubDetails": {
            paddingBottom: theme.spacing(1),
          },
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .contentColumn": {
            flex: "2 0 0",
            "&:last-child": {
              flex: "1 0 0",
            },
            "& p": {
              ...fontStyles.normalText,
            },
            "& .label": {
              paddingBottom: theme.spacing(1),
            },
            "& .content": {
              fontWeight: 600,
            },
          },
          "& .columnDetails": {
            alignContent: "flex-end",
          },
          "& .endColumnDetails": {
            display: "flex",
            justifyContent: "flex-end",
          },
        },
      },
      "& .sellerDetails": {
        paddingTop: theme.spacing(1.75),
        "& .detailsHeader": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
      ...deliveryProofSectionStyles(theme),
      "& .consignmentHistory": {
        paddingBottom: theme.spacing(1),
      },
      '& .tabularSection': {
        paddingBottom: theme.spacing(1),
        '&:last-child': {
          paddingBottom: 0
        },
        ...tabularSectionCratesStyles(theme),
        '& .itemDiv': {
          padding: theme.spacing(0),
          '& .content': {
           ...tabularSectionItemContentStyles(theme),
          }
        }
      }
    },
    accordionSummary: {
      "& .header": {
        ...fontStyles.subHeading,
        paddingBottom: theme.spacing(0.5),
        "&:last-child": {
          paddingBottom: 0,
        },
        "& .smallHeading": {
          fontSize: 12,
        },
      },
      "& .content": {
        flexGrow: 1,
      },
    },
    ...timelineStyles(theme),
    dialogPaperPropsRoot: {
      ...modalStyles().dialogPaper,
    },
    verticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "2px 16px 0px 16px",
    },
    horizontalDiv: {
      borderBottom: "1px solid #E6E6E6",
      marginBottom: "16px",
    },
    countSection: {
      margin: "auto",
      width: 100,
      height: 40,
      borderRadius: 100,
      backgroundColor: COLORS.FOOTER_COUNT_BACKGROUND,
      color: COLORS.WHITE,
      left: "calc(50% - 40px)",
      bottom: "38px",
      position: "fixed",
      zIndex: 100,
      "& .countContainer": {
        height: "100%",
        "& .countItem": {
          margin: "auto",
          "& p": {
            fontSize: 16,
            fontWeight: 400,
          },
          "& .current": {
            fontWeight: 500,
          },
          "& .separator": {
            padding: "0 2px",
          },
        },
      },
    },
   ...useSideModalCloseOpenStyles(),
  })
);
